import 'react/jsx-runtime';
import React from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign$ = function __assign$1() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$.apply(this, arguments);
};

function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator$1(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var defaultUserInfo = {
  avatar: '',
  lives: [],
  loggedIn: false,
  seasonCode: '',
  user: {
    userId: '',
    firstName: '',
    lastName: '',
    role: '',
    shippingCountry: '',
    shippingState: '',
    shippingZipCode: '',
    shippingCity: '',
    subscriptionEndDate: 0,
    subscriptionStartDate: 0,
    subscriptionState: '',
    subscriptionType: ''
  }
};
var defaultContext = {
  userInfo: defaultUserInfo,
  clearStorage: function clearStorage() {},
  invalidateUserCache: function invalidateUserCache() {}
};

function request(path, method, body, json, contentType) {
  if (method === void 0) {
    method = 'GET';
  }

  if (json === void 0) {
    json = true;
  }

  if (contentType === void 0) {
    contentType = 'application/json; charset=utf-8';
  }

  return __awaiter(this, void 0, void 0, function () {
    var defaultHeaders, response, status;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          defaultHeaders = {
            'FFF-Auth': 'V1.1',
            'Content-Type': contentType
          };
          return [4, fetch(path, {
            credentials: 'include',
            headers: _assign({}, defaultHeaders),
            body: method !== 'GET' ? body : null,
            mode: 'cors',
            method: method
          })];

        case 1:
          response = _a.sent();
          status = response.status;

          switch (status) {
            case 200:
              return [2, json ? response.json() : response.text()];

            case 400:
              return [2, Promise.reject(new Error('Bad request'))];

            case 401:
              return [2, Promise.reject(new Error('Unauthorized'))];

            case 403:
              return [2, Promise.reject(new Error('Forbidden'))];

            case 408:
              return [2, Promise.reject(new Error('Timeout'))];

            case 500:
              return [2, Promise.reject(new Error('API internal error'))];

            case 502:
              return [2, Promise.reject(new Error('Proxy error'))];

            case 503:
              return [2, Promise.reject(new Error('Service unavilable'))];

            case 504:
              return [2, Promise.reject(new Error('Timeout'))];

            default:
              return [2, Promise.reject(new Error("Unhandled HTTP code: " + status))];
          }

      }
    });
  });
}

function isBrowser$1() {
  return ![typeof window, typeof document].includes('undefined');
}

var getFromStorage = function getFromStorage(key, defaultItem) {
  if (defaultItem === void 0) {
    defaultItem = null;
  }

  if (!isBrowser$1()) {
    return defaultItem;
  }

  var stgItem = sessionStorage.getItem("FFF_" + key);

  if (!stgItem) {
    return defaultItem;
  }

  try {
    var _a = JSON.parse(stgItem),
        createAt = _a.createAt,
        durationInMs = _a.durationInMs,
        data = _a.data;

    var currentTime = Date.now();
    var isExpired = durationInMs !== 0 && createAt + durationInMs < currentTime;

    if (!durationInMs || createAt && durationInMs && data && !isExpired) {
      return data;
    }

    removeFromStorage(key);
  } catch (error) {
    console.error('Error when deserializing JSON navigation');
  }

  return defaultItem;
};

var setToStorage = function setToStorage(key, value, durationInMs) {
  if (durationInMs === void 0) {
    durationInMs = 0;
  }

  var itemWithExpirationTime = {
    createAt: Date.now(),
    durationInMs: durationInMs,
    data: value
  };
  var json = JSON.stringify(itemWithExpirationTime);

  if (isBrowser$1()) {
    sessionStorage.setItem("FFF_" + key, json);
  }
};

var removeFromStorage = function removeFromStorage(key) {
  if (isBrowser$1()) {
    sessionStorage.removeItem("FFF_" + key);
  }
};

var getEnvUsingWindowLocation = function getEnvUsingWindowLocation() {
  var hostname = 'fabfitfun.com';

  if (isBrowser$1()) {
    hostname = window.location.hostname;
  }

  if (hostname.includes('fabfitfun')) {
    return 'prod';
  }

  if (hostname.includes('fff-staging')) {
    return 'staging';
  }

  if (hostname.includes('fff-qa')) {
    return 'qa';
  }

  return 'dev';
};

var getEnv$1 = function getEnv$1(env) {
  if (process.env && process.env.REACT_APP_NAVIGATOR_URL && process.env.REACT_APP_USER_INFO_URL && process.env.REACT_APP_BASE_URL && process.env.REACT_APP_TIMER_URL && process.env.REACT_APP_NEW_MEMBER_CAMPAIGN_URL && process.env.REACT_APP_NEW_MEMBER_API_URL && process.env.REACT_APP_ENVIRONMENT) {
    return _assign(_assign({}, process.env), {
      name: process.env.REACT_APP_ENVIRONMENT
    });
  }

  var enF = env || getEnvUsingWindowLocation();

  if (enF === 'local') {
    return _assign(_assign({}, getEnv$1('dev')), {
      name: 'local'
    });
  }

  if (enF === 'prod') {
    return {
      name: 'prod',
      REACT_APP_NAVIGATOR_URL: 'https://universal-navigation-api.fabfitfun.com',
      REACT_APP_USER_INFO_URL: 'https://universal-navigation-api.fabfitfun.com/menu/user-data',
      REACT_APP_BASE_URL: 'https://fabfitfun.com',
      REACT_APP_TIMER_URL: 'https://universal-navigation-api.fabfitfun.com/timer',
      REACT_APP_NEW_MEMBER_CAMPAIGN_URL: 'https://customize-api.fabfitfun.com/customize/new-members/self/campaign-state',
      REACT_APP_NEW_MEMBER_API_URL: 'https://new-member-api.fabfitfun.com',
      REACT_APP_BANNER_URL: 'https://homepage-api.fabfitfun.com/megaphone-banners/current',
      REACT_APP_ADDONS_URL: 'https://fabfitfun.com/add-ons',
      REACT_APP_EDIT_URL: 'https://fabfitfun.com/edit'
    };
  }

  return {
    name: enF,
    REACT_APP_NAVIGATOR_URL: "https://universal-navigation-api.fff-" + enF + ".com",
    REACT_APP_USER_INFO_URL: "https://universal-navigation-api.fff-" + enF + ".com/menu/user-data",
    REACT_APP_BASE_URL: "https://fff-" + enF + ".com",
    REACT_APP_TIMER_URL: "https://universal-navigation-api.fff-" + enF + ".com/timer",
    REACT_APP_NEW_MEMBER_CAMPAIGN_URL: "https://customize-api.fff-" + enF + ".com/customize/new-members/self/campaign-state",
    REACT_APP_NEW_MEMBER_API_URL: "https://new-member-api.fff-" + enF + ".com",
    REACT_APP_BANNER_URL: "https://homepage-api.fff-" + enF + ".com/megaphone-banners/current",
    REACT_APP_ADDONS_URL: "https://fff-" + enF + ".com/add-ons",
    REACT_APP_EDIT_URL: "https://fff-" + enF + ".com/edit"
  };
};

var fetchUserInfo = function fetchUserInfo(env) {
  return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, request(env.REACT_APP_USER_INFO_URL)];

        case 1:
          response = _a.sent();
          return [2, response];
      }
    });
  });
};

var userInfoKey = 'user-info-app';
var durationUserInfo = 5 * 60 * 1000;

var getUserInfo = function getUserInfo(forceRefresh) {
  if (forceRefresh === void 0) {
    forceRefresh = false;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var userFromSTG, requestUserInfo, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          userFromSTG = getFromStorage(userInfoKey);

          if (!forceRefresh && userFromSTG) {
            return [2, userFromSTG];
          }

          removeFromStorage(userInfoKey);
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4, fetchUserInfo(getEnv$1(null))];

        case 2:
          requestUserInfo = _a.sent();

          if (requestUserInfo) {
            setToStorage(userInfoKey, requestUserInfo, durationUserInfo);
            return [2, requestUserInfo];
          }

          return [3, 4];

        case 3:
          err_1 = _a.sent();

          if (err_1.message === 'Unauthorized' || err_1.message === 'Forbidden') {
            removeFromStorage(userInfoKey);
          } else {
            console.log(err_1, err_1.message);
          }

          return [3, 4];

        case 4:
          return [2, defaultUserInfo];
      }
    });
  });
};

React.createContext(defaultContext);

var isBrowser = function isBrowser() {
  return ![typeof window, typeof document].includes('undefined');
};

var loadSegment = function loadSegment(_a) {
  var token = _a.token;

  if (!isBrowser()) {
    return false;
  } // eslint-disable-next-line no-multi-assign


  var analytics = window.analytics = window.analytics || [];

  if (!analytics.initialize && !analytics.invoked) {
    analytics.invoked = !0;
    analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware']; // eslint-disable-next-line func-names

    analytics.factory = function (e) {
      // eslint-disable-next-line func-names
      return function () {
        // eslint-disable-next-line prefer-rest-params
        var t = Array.prototype.slice.call(arguments);
        t.unshift(e);
        analytics.push(t);
        return analytics;
      };
    };

    for (var e = 0; e < analytics.methods.length; e++) {
      var key = analytics.methods[e];
      analytics[key] = analytics.factory(key);
    } // eslint-disable-next-line func-names


    analytics.load = function (_a) {
      var _b;

      var key = _a.key,
          e = _a.e;

      if (!isBrowser()) {
        return true;
      }

      var t = document.createElement('script');
      t.type = 'text/javascript';
      t.async = !0;
      t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
      var n = document.getElementsByTagName('script')[0];
      (_b = n === null || n === void 0 ? void 0 : n.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(t, n); // eslint-disable-next-line no-underscore-dangle

      analytics._loadOptions = e;
      return true;
    };

    analytics.SNIPPET_VERSION = '4.13.1';
    analytics.load({
      key: token
    });
    return true;
  }

  return false;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */


var js_cookie = createCommonjsModule(function (module, exports) {
  (function (factory) {
    var registeredInModuleLoader;
    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }

    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }

    function init(converter) {
      function api() {}

      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }

        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
        } // We're using "expires" because "max-age" is not supported by IE


        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          var result = JSON.stringify(value);

          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }

          stringifiedAttributes += '; ' + attributeName;

          if (attributes[attributeName] === true) {
            continue;
          } // Considers RFC 6265 section 5.2:
          // ...
          // 3.  If the remaining unparsed-attributes contains a %x3B (";")
          //     character:
          // Consume the characters of the unparsed-attributes up to,
          // not including, the first %x3B (";") character.
          // ...


          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }

        return document.cookie = key + '=' + value + stringifiedAttributes;
      }

      function get(key, json) {
        if (typeof document === 'undefined') {
          return;
        }

        var jar = {}; // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var cookie = parts.slice(1).join('=');

          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }

          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);

            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            jar[name] = cookie;

            if (key === name) {
              break;
            }
          } catch (e) {}
        }

        return key ? jar[key] : jar;
      }

      api.set = set;

      api.get = function (key) {
        return get(key, false
        /* read as raw */
        );
      };

      api.getJSON = function (key) {
        return get(key, true
        /* read as json */
        );
      };

      api.remove = function (key, attributes) {
        set(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.defaults = {};
      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
});
/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

var uaParser = createCommonjsModule(function (module, exports) {
  (function (window, undefined$1) {
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '0.7.28',
        EMPTY = '',
        UNKNOWN = '?',
        FUNC_TYPE = 'function',
        UNDEF_TYPE = 'undefined',
        OBJ_TYPE = 'object',
        STR_TYPE = 'string',
        MAJOR = 'major',
        // deprecated
    MODEL = 'model',
        NAME = 'name',
        TYPE = 'type',
        VENDOR = 'vendor',
        VERSION = 'version',
        ARCHITECTURE = 'architecture',
        CONSOLE = 'console',
        MOBILE = 'mobile',
        TABLET = 'tablet',
        SMARTTV = 'smarttv',
        WEARABLE = 'wearable',
        EMBEDDED = 'embedded',
        UA_MAX_LENGTH = 255; ///////////
    // Helper
    //////////

    var util = {
      extend: function extend(regexes, extensions) {
        var mergedRegexes = {};

        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }

        return mergedRegexes;
      },
      has: function has(str1, str2) {
        return typeof str1 === STR_TYPE ? str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1 : false;
      },
      lowerize: function lowerize(str) {
        return str.toLowerCase();
      },
      major: function major(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined$1;
      },
      trim: function trim(str, len) {
        str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    }; ///////////////
    // Map helper
    //////////////

    var mapper = {
      rgx: function rgx(ua, arrays) {
        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match; // loop through all regexes maps

        while (i < arrays.length && !matches) {
          var regex = arrays[i],
              // even sequence (0,2,4,..)
          props = arrays[i + 1]; // odd sequence (1,3,5,..)

          j = k = 0; // try matching uastring with regexes

          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);

            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p]; // check if given property is actually array

                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }

          i += 2;
        }
      },
      str: function str(_str, map) {
        for (var i in map) {
          // check if array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], _str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (util.has(map[i], _str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }

        return _str;
      }
    }; ///////////////
    // String map
    //////////////

    var maps = {
      browser: {
        // Safari < 3.0
        oldSafari: {
          version: {
            '1.0': '/8',
            '1.2': '/1',
            '1.3': '/3',
            '2.0': '/412',
            '2.0.2': '/416',
            '2.0.3': '/417',
            '2.0.4': '/419',
            '?': '/'
          }
        },
        oldEdge: {
          version: {
            '0.1': '12.',
            '21': '13.',
            '31': '14.',
            '39': '15.',
            '41': '16.',
            '42': '17.',
            '44': '18.'
          }
        }
      },
      os: {
        windows: {
          version: {
            'ME': '4.90',
            'NT 3.11': 'NT3.51',
            'NT 4.0': 'NT4.0',
            '2000': 'NT 5.0',
            'XP': ['NT 5.1', 'NT 5.2'],
            'Vista': 'NT 6.0',
            '7': 'NT 6.1',
            '8': 'NT 6.2',
            '8.1': 'NT 6.3',
            '10': ['NT 6.4', 'NT 10.0'],
            'RT': 'ARM'
          }
        }
      }
    }; //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, 'Edge']], [// breaking change (reserved for next major release):
      ///edge\/([\w\.]+)/i                                                  // Old Edge (Trident)
      //], [[VERSION, mapper.str, maps.browser.oldEdge.version], [NAME, 'Edge']], [
      // Presto based
      /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
      /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, 'Opera Mini']], [/\sopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, 'Opera']], [// Mixed
      /(kindle)\/([\w\.]+)/i, // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
      /(ba?idubrowser)[\/\s]?([\w\.]+)/i, // Baidu Browser
      /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
      // Webkit/KHTML based
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i, // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i, // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, 'UCBrowser']], [/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i // WeChat Desktop for Windows Built-in Browser
      ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i // IE11
      ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, '$1 Secure Browser'], VERSION], [/focus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, 'Firefox Focus']], [/opt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, 'Opera Touch']], [/coc_coc_browser\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, 'Opera Coast']], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, 'MIUI Browser']], [/fxios\/([\w\.-]+)/i // Firefox for iOS
      ], [VERSION, [NAME, 'Firefox']], [/(qihu|qhbrowser|qihoobrowser|360browser)/i // 360
      ], [[NAME, '360 Browser']], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 Browser'], VERSION], [// Oculus/Samsung/Sailfish Browser
      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, ' '], VERSION], [/\s(electron)\/([\w\.]+)\ssafari/i, // Electron-based App
      /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i, // Tesla
      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i, // SouGouBrowser
      /(LBBROWSER)/i // LieBao Browser
      ], [NAME], [// WebView
      /;fbav\/([\w\.]+);/i // Facebook App for iOS & Android with version
      ], [VERSION, [NAME, 'Facebook']], [/FBAN\/FBIOS|FB_IAB\/FB4A/i // Facebook App for iOS & Android without version
      ], [[NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
      /(chromium|instagram)[\/\s]([\w\.-]+)/i // Chromium/Instagram
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+)\s.*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
      ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, 'Chrome WebView'], VERSION], [/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i // Android Browser
      ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i // Mobile Safari
      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, mapper.str, maps.browser.oldSafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
      /(navigator|netscape)\/([\w\.-]+)/i // Netscape
      ], [[NAME, 'Netscape'], VERSION], [/ile\svr;\srv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, 'Firefox Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
      /(swiftfox)/i, // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i, // Other Firefox-based
      /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i, // Mozilla
      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
      /(links)\s\(([\w\.]+)/i, // Links
      /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
      /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
      /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
      ], [NAME, VERSION]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|armv?8e?l?)\b/i // ARM64
      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, 'armhf']], [// PocketPC mistakenly identified as PowerPC
      /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, util.lowerize]]],
      device: [[//////////////////////////
      // MOBILES & TABLETS
      // Ordered by popularity
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i], [MODEL, [VENDOR, 'Samsung'], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i, /\ssamsung[\s-]([\w-]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, 'Samsung'], [TYPE, MOBILE]], [// Apple
      /\((ip(?:hone|od)[\s\w]*);/i // iPod/iPhone
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/\((ipad);[\w\s\),;-]+apple/i, // iPad
      /applecoremedia\/[\w\.]+\s\((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [// Huawei
      /\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i, /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [// Xiaomi
      /\b(poco[\s\w]+)(?:\sbuild|\))/i, // Xiaomi POCO
      /\b;\s(\w+)\sbuild\/hm\1/i, // Xiaomi Hongmi 'numeric' models
      /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i, // Xiaomi Hongmi
      /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i, // Xiaomi Redmi
      /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i // Xiaomi Mi
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [// OPPO
      /;\s(\w+)\sbuild.+\soppo/i, /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [// Vivo
      /\svivo\s(\w+)(?:\sbuild|\))/i, /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [// Realme
      /\s(rmx[12]\d{3})(?:\sbuild|;)/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [// Motorola
      /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i, /\smot(?:orola)?[\s-](\w*)/i, /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [// LG
      /((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/(lm-?f100[nv]?|nexus\s[45])/i, /lg[e;\s\/-]+((?!browser|netcast)\w+)/i, /\blg(\-?[\d\w]+)\sbuild/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [// Lenovo
      /(ideatab[\w\-\s]+)/i, /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i // Lenovo tablets
      ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [// Nokia
      /(?:maemo|nokia).*(n900|lumia\s\d+)/i, /nokia[\s_-]?([\w\.-]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [// Google
      /droid.+;\s(pixel\sc)[\s)]/i // Google Pixel C
      ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i // Google Pixel
      ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [// Sony
      /droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/sony\stablet\s[ps]\sbuild\//i, /(?:sony)?sgp\w+(?:\sbuild\/|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, 'Sony'], [TYPE, TABLET]], [// OnePlus
      /\s(kb2005|in20[12]5|be20[12][59])\b/i, /\ba000(1)\sbuild/i, // OnePlus
      /\boneplus\s(a\d{4})[\s)]/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [// Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi)(\sbuild\/|\))/i, // Kindle Fire without Silk
      /(kf[a-z]+)(\sbuild\/|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i // Fire Phone
      ], [[MODEL, 'Fire Phone'], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [// BlackBerry
      /\((playbook);[\w\s\),;-]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10;\s(\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [// Asus
      /(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i], [MODEL, [VENDOR, 'ASUS'], [TYPE, TABLET]], [/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i], [MODEL, [VENDOR, 'ASUS'], [TYPE, MOBILE]], [// HTC
      /(nexus\s9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i, // HTC
      // ZTE
      /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [// Acer
      /droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [// Meizu
      /droid.+;\s(m[1-5]\snote)\sbuild/i, /\bmz-([\w-]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [// MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp)\s([\w\s]+\w)/i, // HP iPAQ
      /(asus)-?(\w+)/i, // Asus
      /(microsoft);\s(lumia[\s\w]+)/i, // Microsoft Lumia
      /(lenovo)[_\s-]?([\w-]+)/i, // Lenovo
      /linux;.+(jolla);/i, // Jolla
      /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos)\s(gamepad2?)/i, // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
      /(kindle)\/([\w\.]+)/i, // Kindle
      /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
      /(dell)\s(strea[kpr\s\d]*[\dko])/i, // Dell Streak
      /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i, // Le Pan Tablets
      /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i, // Trinity Tablets
      /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i, // Gigaset Tablets
      /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(surface\sduo)\s/i // Surface Duo
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, TABLET]], [/droid\s[\d\.]+;\s(fp\du?)\sbuild/i], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/\s(u304aa)\sbuild/i // AT&T
      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/[;\/]\s?(rct\w+)\sbuild/i // RCA Tablets
      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/[;\/\s](venue[\d\s]{2,7})\sbuild/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i // Verizon Tablet
      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/[;\/]\s(tm\d{3}\w+)\sbuild/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/;\s(k88)\sbuild/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/;\s(nx\d{3}j)\sbuild/i // ZTE Nubia
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/[;\/]\s?(gen\d{3})\sbuild.*49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/[;\/]\s?(zur\d{3})\sbuild/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/[;\/]\s?((zeki)?tb.*\b)\sbuild/i // Zeki Tablets
      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/[;\/]\s([yr]\d{2})\sbuild/i, /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i // Dragon Touch Tablet
      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/[;\/]\s?(ns-?\w{0,9})\sbuild/i // Insignia Tablets
      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i // NextBook Tablets
      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
      /[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i // LvTel Phones
      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/;\s(ph-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
      /[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i // Envizen Tablets
      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/[;\/]\s?tu_(1491)\sbuild/i // Rotor Tablets
      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w\s]+)\sbuild/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint)\s(\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, 'Zebra'], [TYPE, TABLET]], [/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, 'Zebra'], [TYPE, MOBILE]], [///////////////////
      // CONSOLES
      ///////////////////
      /\s(ouya)\s/i, // Ouya
      /(nintendo)\s([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+;\s(shield)\sbuild/i // Nvidia
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i // LG SmartTV
      ], [[VENDOR, 'LG'], [TYPE, SMARTTV]], [/(apple)\s?tv/i // Apple TV
      ], [VENDOR, [MODEL, 'Apple TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [/droid.+aft([\w])(\sbuild\/|\))/i // Fire TV
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [///////////////////
      // WEARABLES
      ///////////////////
      /((pebble))app\/[\d\.]+\s/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+;\s(glass)\s\d/i // Google Glass
      ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i], [MODEL, [VENDOR, 'Zebra'], [TYPE, WEARABLE]], [///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
      /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
      ], [[TYPE, util.lowerize]], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
      ], [MODEL, [VENDOR, 'Generic']], [/(phone)/i], [[TYPE, MOBILE]]],
      engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, 'EdgeHTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i, // Flow
      /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
      /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[// Windows
      /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
      /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
      /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [// iOS/macOS
      /ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i, // iOS
      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i // Mac OS
      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Mobile OSes                                                      // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
      /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
      /(tizen|kaios)[\/\s]([\w\.]+)/i, // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, 'BlackBerry']], [/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, 'Symbian']], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
      ], [[NAME, 'Firefox OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, 'webOS']], [// Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, 'Chromecast']], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
      ], [[NAME, 'Chromium OS'], VERSION], [// Console
      /(nintendo|playstation)\s([wids345portablevuch]+)/i, // Nintendo/Playstation
      /(xbox);\s+xbox\s([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)
      // GNU/Linux based
      /(mint)[\/\s\(\)]?(\w*)/i, // Mint
      /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
      /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
      // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
      /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
      /(gnu)\s?([\w\.]*)/i, // GNU
      // BSD based
      /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
      /(haiku)\s(\w+)/i // Haiku
      ], [NAME, VERSION], [// Other
      /(sunos)\s?([\w\.\d]*)/i // Solaris
      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
      /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
      /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
      /(unix)\s?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    }; /////////////////
    // Constructor
    ////////////////

    var UAParser = function UAParser(ua, extensions) {
      if (typeof ua === 'object') {
        extensions = ua;
        ua = undefined$1;
      }

      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }

      var _ua = ua || (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

      var _rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

      this.getBrowser = function () {
        var _browser = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_browser, _ua, _rgxmap.browser);
        _browser.major = util.major(_browser.version); // deprecated

        return _browser;
      };

      this.getCPU = function () {
        var _cpu = {
          architecture: undefined$1
        };
        mapper.rgx.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };

      this.getDevice = function () {
        var _device = {
          vendor: undefined$1,
          model: undefined$1,
          type: undefined$1
        };
        mapper.rgx.call(_device, _ua, _rgxmap.device);
        return _device;
      };

      this.getEngine = function () {
        var _engine = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };

      this.getOS = function () {
        var _os = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_os, _ua, _rgxmap.os);
        return _os;
      };

      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };

      this.getUA = function () {
        return _ua;
      };

      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? util.trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };

      this.setUA(_ua);
      return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
      NAME: NAME,
      MAJOR: MAJOR,
      // deprecated
      VERSION: VERSION
    };
    UAParser.CPU = {
      ARCHITECTURE: ARCHITECTURE
    };
    UAParser.DEVICE = {
      MODEL: MODEL,
      VENDOR: VENDOR,
      TYPE: TYPE,
      CONSOLE: CONSOLE,
      MOBILE: MOBILE,
      SMARTTV: SMARTTV,
      TABLET: TABLET,
      WEARABLE: WEARABLE,
      EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
      NAME: NAME,
      VERSION: VERSION
    };
    UAParser.OS = {
      NAME: NAME,
      VERSION: VERSION
    }; ///////////
    // Export
    //////////
    // check js environment

    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      }

      exports.UAParser = UAParser;
    } // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.

    var $ = typeof window !== 'undefined' && (window.jQuery || window.Zepto);

    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();

      $.ua.get = function () {
        return parser.getUA();
      };

      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();

        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === 'object' ? window : commonjsGlobal);
});

var hostname = function hostname() {
  return isBrowser() ? window.location.hostname : 'fabfitfun.com';
};

var getEnv = function getEnv() {
  if (hostname().includes('fabfitfun')) {
    return {
      name: 'prod',
      originUrl: 'fabfitfun.com',
      segmentToken: '7kbHDCgVdd'
    };
  }

  if (hostname().includes('fff-staging')) {
    return {
      name: 'staging',
      originUrl: 'fff-staging.com',
      segmentToken: 'vVhAGbpFsr2EJsYiB1e4y0IMnzMl10T8'
    };
  }

  if (hostname().includes('fff-qa')) {
    return {
      name: 'qa',
      originUrl: 'fff-qa.com',
      segmentToken: '13meRIwJgrTiyjmcHpuNKjg4DztAEF8L'
    };
  }

  return {
    name: 'dev',
    originUrl: 'fff-dev.com',
    segmentToken: 'hNqaG11W3uumnIjKGU7cwCx6vduBrmc8'
  };
};

var SESSION_INFO_KEY = 'sm_session_info';
/* eslint-disable no-bitwise */

var getGenericTrackingData = function getGenericTrackingData() {
  var sessionInfo = js_cookie.getJSON(SESSION_INFO_KEY);

  if (!sessionInfo) {
    var sessionId = getUuid();
    var sessionCreationDate = new Date();
    js_cookie.set(SESSION_INFO_KEY, {
      sessionId: sessionId,
      sessionCreationDate: sessionCreationDate
    }, {
      domain: getEnv().originUrl,
      path: '/',
      expires: 1 / 24 / 2
    });
    return {
      device: getDevice(),
      sessionId: sessionId,
      sessionCreationDate: sessionCreationDate
    };
  }

  return {
    device: getDevice(),
    sessionId: sessionInfo.sessionId,
    sessionCreationDate: sessionInfo.sessionCreationDate
  };
};

var getDevice = function getDevice() {
  var deviceRegex = [[/(Intel Mac OS|PPC Mac OS)/i], [[uaParser.DEVICE.VENDOR, 'Apple'], [uaParser.DEVICE.TYPE, 'Desktop']], [/(Windows NT|Linux i686)/i], [[uaParser.DEVICE.TYPE, 'Desktop']], [/(Linux armv7l|Mobile)/i], [[uaParser.DEVICE.TYPE, 'Mobile Web']], [/(Tablet|iPad)/i], [[uaParser.DEVICE.TYPE, 'Tablet Web']]];
  var parser = new uaParser(undefined, {
    device: deviceRegex
  });
  var type = parser.getResult().device.type;
  return type;
}; // Matches legacy session IDs


var getUuid = function getUuid() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var warnMessages = {
  TRACK_NAME_IS_REQUIRED: 'trackName parameter is required',
  ANALYTICS_IS_NOT_INITIALIZED: 'windows analytics is not initialized',
  ELEMENT_PARAMETER_IS_REQUIRED: 'elementName parameter is required',
  CTA_NAME_IS_REQUIRED: 'cta_name parameter is required'
};
/* eslint-disable no-console */

var trackNameIsRequired = function trackNameIsRequired() {
  return console.warn(warnMessages.TRACK_NAME_IS_REQUIRED);
};

var analyticsIsNotInitialized = function analyticsIsNotInitialized() {
  return console.warn(warnMessages.ANALYTICS_IS_NOT_INITIALIZED);
};

var elementParameterIsRequired = function elementParameterIsRequired() {
  return console.warn(warnMessages.ELEMENT_PARAMETER_IS_REQUIRED);
};

var ctaNameIsRequired = function ctaNameIsRequired() {
  return console.warn(warnMessages.CTA_NAME_IS_REQUIRED);
};

var trackInfo = function trackInfo(_a) {
  var _b;

  var fffAnalytics = _a.fffAnalytics,
      localStorageUserInfo = _a.localStorageUserInfo,
      _c = _a.properties,
      properties = _c === void 0 ? {} : _c;
  return _assign$(_assign$({
    shipping_country: (_b = localStorageUserInfo === null || localStorageUserInfo === void 0 ? void 0 : localStorageUserInfo.user) === null || _b === void 0 ? void 0 : _b.shippingCountry,
    season_code: localStorageUserInfo === null || localStorageUserInfo === void 0 ? void 0 : localStorageUserInfo.seasonCode
  }, fffAnalytics.sessionInfo), properties);
};

var isString = function isString(s) {
  return typeof s === 'string';
};

var formatString = function formatString(s) {
  if (!isString(s)) return '';
  return s.trim().toLocaleLowerCase();
};

var formatRole = function formatRole(role) {
  var formattedRole = formatString(role);

  switch (formattedRole) {
    case 'select':
      {
        return 'select';
      }

    case 'customer':
      {
        return 'customer';
      }

    case 'expired':
      {
        return 'customer';
      }

    case 'trial':
      {
        return 'customer';
      }

    default:
      {
        return undefined;
      }
  }
};

var formatMemberStatus = function formatMemberStatus(subscriptionState) {
  var formattedSubscriptionState = formatString(subscriptionState);

  switch (formattedSubscriptionState) {
    case 'active':
      {
        return 'Active';
      }

    case 'canceled':
      {
        return 'Voluntary Cancel';
      }

    case 'cancelled_with_zero_boxes':
      {
        return 'Voluntary Cancel';
      }

    case 'cancelledwithzeroboxes':
      {
        return 'Voluntary Cancel';
      }

    case 'future':
      {
        return 'Voluntary Cancel';
      }

    case 'expired':
      {
        return 'Expired';
      }

    default:
      {
        return undefined;
      }
  }
};

var formatPlanCode = function formatPlanCode(planCode) {
  var lowerPlanCode = formatString(planCode);

  switch (lowerPlanCode) {
    case 'fffvip':
      {
        return 'VIP';
      }

    case 'fffvipa':
      {
        return 'VIPA';
      }

    case 'ffftrial':
      {
        return 'Trial';
      }

    case 'fffsocial':
      {
        return 'FFFSOCIAL';
      }

    default:
      {
        return undefined;
      }
  }
};

var identifyInfo = function identifyInfo(_a) {
  var _b, _c, _d;

  var userInfo = _a.userInfo,
      traits = _a.traits;
  return {
    role: formatRole((traits === null || traits === void 0 ? void 0 : traits.role) || ((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) === null || _b === void 0 ? void 0 : _b.role) || ''),
    member_status: formatMemberStatus((traits === null || traits === void 0 ? void 0 : traits.memberStatus) || ((_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) === null || _c === void 0 ? void 0 : _c.subscriptionState) || ''),
    plan_code: formatPlanCode((traits === null || traits === void 0 ? void 0 : traits.planCode) || ((_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) === null || _d === void 0 ? void 0 : _d.planCode) || ''),
    experiment_name: traits === null || traits === void 0 ? void 0 : traits.experimentName,
    variation_name: traits === null || traits === void 0 ? void 0 : traits.variationName,
    feature_flag_name: traits === null || traits === void 0 ? void 0 : traits.featureFlagName,
    campaign_id: traits === null || traits === void 0 ? void 0 : traits.campaignId,
    device: getDevice()
  };
};

var fffAnalytics;

if (isBrowser()) {
  // eslint-disable-next-line no-multi-assign
  fffAnalytics = window.fffAnalytics = window.fffAnalytics || {
    segmentToken: getEnv().segmentToken,
    userData: {},
    sessionInfo: getGenericTrackingData(),
    init: false
  };
}

var initialize = function initialize() {
  return __awaiter$1(void 0, void 0, void 0, function () {
    var _a;

    return __generator$1(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!fffAnalytics) return [2
          /*return*/
          ];
          if (!fffAnalytics.init) fffAnalytics.init = loadSegment({
            token: fffAnalytics.segmentToken
          });
          fffAnalytics.sessionInfo = getGenericTrackingData();
          _a = fffAnalytics;
          return [4
          /*yield*/
          , getUserInfo()];

        case 1:
          _a.userData = _b.sent();
          return [2
          /*return*/
          ];
      }
    });
  });
};

var trackPageLoad = function trackPageLoad(pageLoadProps) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    var defaultBehavior, _a, pathName, properties, options, callback, localStorageUserInfo, page, trackProperties;

    return __generator$1(this, function (_b) {
      switch (_b.label) {
        case 0:
          defaultBehavior = {
            pathName: null,
            properties: {},
            options: {},
            callback: function callback() {
              return null;
            }
          };
          _a = pageLoadProps || defaultBehavior, pathName = _a.pathName, properties = _a.properties, options = _a.options, callback = _a.callback;
          if (!isBrowser() || !window.analytics) return [2
          /*return*/
          , analyticsIsNotInitialized()];
          return [4
          /*yield*/
          , getUserInfo()];

        case 1:
          localStorageUserInfo = _b.sent();
          fffAnalytics.userData = localStorageUserInfo;
          page = pathName || isBrowser() ? window.location.pathname : '';
          trackProperties = trackInfo({
            fffAnalytics: fffAnalytics,
            localStorageUserInfo: localStorageUserInfo,
            properties: properties
          });
          window.analytics.page(page, trackProperties, options, callback);
          return [2
          /*return*/
          ];
      }
    });
  });
};

var trackEvent = function trackEvent(_a) {
  var ctaName = _a.ctaName,
      _b = _a.properties,
      properties = _b === void 0 ? {} : _b,
      _c = _a.options,
      options = _c === void 0 ? {} : _c,
      _d = _a.callback,
      callback = _d === void 0 ? function () {
    return null;
  } : _d;
  return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator$1(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (!ctaName) return [2
          /*return*/
          , ctaNameIsRequired()];
          return [4
          /*yield*/
          , track({
            trackName: 'Clicked CTA',
            properties: _assign$({
              cta_name: ctaName
            }, properties),
            options: options,
            callback: callback
          })];

        case 1:
          _e.sent();

          return [2
          /*return*/
          ];
      }
    });
  });
};

var trackElement = function trackElement(_a) {
  var elementName = _a.elementName,
      _b = _a.properties,
      properties = _b === void 0 ? {} : _b,
      _c = _a.options,
      options = _c === void 0 ? {} : _c,
      _d = _a.callback,
      callback = _d === void 0 ? function () {
    return null;
  } : _d;
  return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator$1(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (!elementName) return [2
          /*return*/
          , elementParameterIsRequired()];
          return [4
          /*yield*/
          , track({
            trackName: 'Clicked Element',
            properties: _assign$({
              element_name: elementName
            }, properties),
            options: options,
            callback: callback
          })];

        case 1:
          _e.sent();

          return [2
          /*return*/
          ];
      }
    });
  });
};

var track = function track(_a) {
  var trackName = _a.trackName,
      _b = _a.properties,
      properties = _b === void 0 ? {} : _b,
      _c = _a.options,
      options = _c === void 0 ? {} : _c,
      _d = _a.callback,
      callback = _d === void 0 ? function () {
    return null;
  } : _d;
  return __awaiter$1(void 0, void 0, void 0, function () {
    var localStorageUserInfo, trackProperties;
    return __generator$1(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (!trackName) return [2
          /*return*/
          , trackNameIsRequired()];
          if (!isBrowser() || !window.analytics) return [2
          /*return*/
          , analyticsIsNotInitialized()];
          return [4
          /*yield*/
          , getUserInfo()];

        case 1:
          localStorageUserInfo = _e.sent();
          fffAnalytics.userData = localStorageUserInfo;
          trackProperties = trackInfo({
            fffAnalytics: fffAnalytics,
            localStorageUserInfo: localStorageUserInfo,
            properties: properties
          });
          window.analytics.track(trackName, trackProperties, options, callback);
          return [2
          /*return*/
          ];
      }
    });
  });
};

var identify = function identify(identifyProps) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    var defaultIdentifyProps, _a, userId, traits, options, callback, localStorageUserInfo, identifyProperties, identifyUserId;

    var _b;

    return __generator$1(this, function (_c) {
      switch (_c.label) {
        case 0:
          defaultIdentifyProps = {
            userId: '',
            traits: {},
            options: {},
            callback: function callback() {
              return null;
            }
          };
          _a = identifyProps || defaultIdentifyProps, userId = _a.userId, traits = _a.traits, options = _a.options, callback = _a.callback;
          if (!isBrowser() || !window.analytics) return [2
          /*return*/
          , analyticsIsNotInitialized()];
          return [4
          /*yield*/
          , getUserInfo()];

        case 1:
          localStorageUserInfo = _c.sent();
          fffAnalytics.userData = localStorageUserInfo;
          identifyProperties = identifyInfo({
            userInfo: localStorageUserInfo,
            traits: traits
          });
          identifyUserId = userId || ((_b = localStorageUserInfo === null || localStorageUserInfo === void 0 ? void 0 : localStorageUserInfo.user) === null || _b === void 0 ? void 0 : _b.userId);
          if (window.analytics.user) window.analytics.user().traits({});
          window.analytics.identify(identifyUserId, identifyProperties, options, callback);
          return [2
          /*return*/
          ];
      }
    });
  });
};

export { identify, initialize, track, trackElement, trackEvent, trackPageLoad };